import { render } from "./Checkbox.vue?vue&type=template&id=59070a9c"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=59070a9c&lang=sass"
script.render = render

export default script